module.exports = "<div class=\"col-sm-9 col-md-10 main\">\n  <h1 class=\"page-header\">Start of Day Non-Base Cash Position Event Log</h1>\n  <div id='jqxWidget'\tstyle=\"font-size: 13px; font-family: Verdana; float: left; width: 100%; height: 50%;\">\n    <div id=\"jqxgrid\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/sod-cash-h/sod-cash-h.component.html
// module id = ../../../../../src/app/pages/history/sod-cash-h/sod-cash-h.component.html
// module chunks = main